<template>
  <div
    class="alert alert-custom alert-white alert-shadow gutter-b"
    role="alert"
  >
    <div class="text-center mx-auto">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
      <p class="lead d-inline pl-1">Loading <slot></slot>...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader"
};
</script>
